/*
 * The preview's FIELD ROWS (#2351).
 *
 * `PeekRow` rendered each field as an unstyled `<div>` with two bare `<span>`s,
 * so a label and its value ran together as one word — measured in the governed
 * raster of the relationship workspace's preview, which read
 *
 *     First NameChris    Last NameWilkinson    HonorificMr
 *
 * That is not a workspace defect: `PeekPanel.module.css` styles the panel and
 * leaves the field rendering to its host, and the host drew no rows. So the
 * same three words ran together in the record page's own Peek lens, which has
 * shipped since #2281. Fixing it here fixes both, because there is one host.
 *
 * A label/value pair, which is what the #2351 mockup draws and what
 * `FormLayoutSections` does for the full record: the label reads quietly on the
 * left, the value carries the weight on the right, and a long value wraps
 * rather than pushing the label out of the row.
 *
 * Closed token vocabulary only, the same one `PeekPanel.module.css` declares.
 */

.field {
  display: grid;
  grid-template-columns: minmax(0, auto) minmax(0, 1fr);
  gap: var(--sp-3);
  align-items: baseline;
  padding: var(--sp-1) 0;
}

.label {
  color: var(--muted);
  font-size: var(--fs-sm);
}

.value {
  color: var(--ink);
  font-size: var(--fs-sm);
  font-weight: 600;
  text-align: right;
  overflow-wrap: anywhere;
}
